import {NavigationTabsModuleTabModel} from "./navigation-tabs-module.tab-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {override} from "mobx";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class NewsTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: EntityViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: EntityViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @override get isVisible(): Boolean {
    return true;
  }

  get eventName(): String {
    return ACTION_TYPES.newsClick;
  }

  get eventParams(): Object {
    const eventParams = {
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[this.entity.objectType],
      entityId: this.entity.id,
      source: APP.ANALYTICS.SOURCES[this.currentLinkModel.name],
      sportTypeId: this.entity.sport.id
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.news;
  }

  get elementId(): String {
    return 'navigation-tabs_news';
  }
}
